export const REPORT_NAVIGATED_EVENT = 'xxx - Report Navigated (Client)'
export const REPORT_TIME_SPENT_EVENT = 'xxx - Report Time Spent (Client)'
export const REPORT_VIEWED_EVENT = 'xxx - Report Viewed (Client)'
